window.ShoogieGolfComponentBuilderData = {
  "generatedAt": "2026-08-03T23:00:18.557Z",
  "shells": [
    {
      "productId": "8895274025014",
      "variantId": "46696716927030",
      "gid": "gid://shopify/ProductVariant/46696716927030",
      "handle": "black-and-white-shoe-shell-pair",
      "sourceHandles": [
        "black-white-shoes"
      ],
      "title": "Black & White",
      "fullTitle": "Black & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "black-and-white",
      "colors": [
        "black",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-BLACK-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/black-and-white-shoe-shell-pair-1.jpg?v=1793073082"
    },
    {
      "productId": "8895274287158",
      "variantId": "46696717189174",
      "gid": "gid://shopify/ProductVariant/46696717189174",
      "handle": "blue-sandal-shell-pair",
      "sourceHandles": [],
      "title": "Blue",
      "fullTitle": "Blue Sandal Shell Pair",
      "kind": "sandal",
      "family": "sandal",
      "colorHandle": "blue",
      "colors": [
        "blue"
      ],
      "strapColor": "",
      "sku": "SHL-SANDAL-BLUE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 5,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/blue-sandal-shell-pair-1_3997b185-4c6b-4cda-be5a-e721b62d2353.jpg?v=1793074151"
    },
    {
      "productId": "8895274057782",
      "variantId": "46696716959798",
      "gid": "gid://shopify/ProductVariant/46696716959798",
      "handle": "blue-and-black-shoe-shell-pair",
      "sourceHandles": [
        "blue-black-golf-bag-stand-shoes"
      ],
      "title": "Blue & Black",
      "fullTitle": "Blue & Black Shoe Shell Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "blue-and-black",
      "colors": [
        "black",
        "blue"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-BLUE-BLACK-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 2,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/blue-and-black-shoe-shell-pair-1_a7f598a2-7c03-4166-8cd0-a1345d5628d3.jpg?v=1793074812"
    },
    {
      "productId": "8895274090550",
      "variantId": "46696716992566",
      "gid": "gid://shopify/ProductVariant/46696716992566",
      "handle": "blue-and-white-shoe-shell-pair",
      "sourceHandles": [
        "blue-white-shoes"
      ],
      "title": "Blue & White",
      "fullTitle": "Blue & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "blue-and-white",
      "colors": [
        "blue",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-BLUE-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/blue-and-white-shoe-shell-pair-1.jpg?v=1793073090"
    },
    {
      "productId": "9587086327862",
      "variantId": "48318685806646",
      "gid": "gid://shopify/ProductVariant/48318685806646",
      "handle": "blue-camo-shoe-pair",
      "sourceHandles": [],
      "title": "Blue Camo",
      "fullTitle": "Blue Camo Shoe Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "blue-camo",
      "colors": [
        "blue",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-BLUE-CAMO-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/blue-camo-shoe-pair-1.jpg?v=1793080415"
    },
    {
      "productId": "8895274123318",
      "variantId": "46696717025334",
      "gid": "gid://shopify/ProductVariant/46696717025334",
      "handle": "blue-black-and-white-shoe-shell-pair",
      "sourceHandles": [
        "red-black-white-golf-bag-stand-shoes-copy"
      ],
      "title": "Blue/Black & White",
      "fullTitle": "Blue/Black & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "three-color",
      "colorHandle": "blue-black-and-white",
      "colors": [
        "black",
        "blue",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-BLUE-BLACK-WHITE-PAIR",
      "priceCents": 1800,
      "inventoryQuantity": 14,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/blue-black-and-white-shoe-shell-pair-1_5ecf6a7d-c241-4535-8a13-b500c3b6ebcd.jpg?v=1793073428"
    },
    {
      "productId": "8895274156086",
      "variantId": "46696717058102",
      "gid": "gid://shopify/ProductVariant/46696717058102",
      "handle": "bronze-and-white-shoe-shell-pair",
      "sourceHandles": [
        "bronze-white-golf-bag-stand-shoes"
      ],
      "title": "Bronze & White",
      "fullTitle": "Bronze & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "bronze-and-white",
      "colors": [
        "bronze",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-BRONZE-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 4,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/bronze-and-white-shoe-shell-pair-1_0c447a32-76d5-41ec-a9a8-40b88f0295b0.jpg?v=1793080323"
    },
    {
      "productId": "8895274188854",
      "variantId": "46696717090870",
      "gid": "gid://shopify/ProductVariant/46696717090870",
      "handle": "bryan-bros-shoe-shell-pair",
      "sourceHandles": [
        "bryan-bros-golf-bag-stand-shoes"
      ],
      "title": "Bryan Bros",
      "fullTitle": "Bryan Bros Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "bryan-bros",
      "colors": [
        "blue",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-BRYAN-BROS-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 181,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/bryan-bros-shoe-shell-pair-1.jpg?v=1793080383"
    },
    {
      "productId": "8895274221622",
      "variantId": "46696717123638",
      "gid": "gid://shopify/ProductVariant/46696717123638",
      "handle": "glow-in-the-dark-shoe-shell-pair",
      "sourceHandles": [
        "neon-black-golf-bag-stand-shoes-copy"
      ],
      "title": "Glow in the Dark",
      "fullTitle": "Glow in the Dark Shoe Shell Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "glow-in-the-dark",
      "colors": [],
      "strapColor": "",
      "sku": "SHL-SHOE-GLOW-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 5,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/IMG_5764_3ce70430-7972-4ec5-8780-53b05eb8528f.jpg?v=1785627071"
    },
    {
      "productId": "8895274385462",
      "variantId": "46696717287478",
      "gid": "gid://shopify/ProductVariant/46696717287478",
      "handle": "green-and-black-shoe-shell-pair",
      "sourceHandles": [
        "green-black-golf-bag-stand-shoes"
      ],
      "title": "Green & Black",
      "fullTitle": "Green & Black Shoe Shell Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "green-and-black",
      "colors": [
        "black",
        "green"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-GREEN-BLACK-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 5,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/green-and-black-shoe-shell-pair-1.jpg?v=1793080390"
    },
    {
      "productId": "8895274418230",
      "variantId": "46696717320246",
      "gid": "gid://shopify/ProductVariant/46696717320246",
      "handle": "green-and-white-shoe-shell-pair",
      "sourceHandles": [
        "green-white-shoes"
      ],
      "title": "Green & White",
      "fullTitle": "Green & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "green-and-white",
      "colors": [
        "green",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-GREEN-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/green-and-white-shoe-shell-pair-1.jpg?v=1793073107"
    },
    {
      "productId": "8895274450998",
      "variantId": "46696717353014",
      "gid": "gid://shopify/ProductVariant/46696717353014",
      "handle": "green-black-and-white-shoe-shell-pair",
      "sourceHandles": [
        "green-black-white-golf-bag-stand-shoes"
      ],
      "title": "Green/Black & White",
      "fullTitle": "Green/Black & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "three-color",
      "colorHandle": "green-black-and-white",
      "colors": [
        "black",
        "green",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-GREEN-BLACK-WHITE-PAIR",
      "priceCents": 1800,
      "inventoryQuantity": 13,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/green-black-and-white-shoe-shell-pair-1.jpg?v=1793080364"
    },
    {
      "productId": "9587085279286",
      "variantId": "48318683086902",
      "gid": "gid://shopify/ProductVariant/48318683086902",
      "handle": "grey-camo-shoe-pair",
      "sourceHandles": [],
      "title": "Grey Camo",
      "fullTitle": "Grey Camo Shoe Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "grey-camo",
      "colors": [
        "blue",
        "gray",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-GREY-CAMO-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/grey-camo-shoe-pair-1.jpg?v=1793074171"
    },
    {
      "productId": "8895274483766",
      "variantId": "46696717385782",
      "gid": "gid://shopify/ProductVariant/46696717385782",
      "handle": "neon-and-black-shoe-shell-pair",
      "sourceHandles": [
        "neon-black-golf-bag-stand-shoes"
      ],
      "title": "Neon & Black",
      "fullTitle": "Neon & Black Shoe Shell Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "neon-and-black",
      "colors": [
        "black"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-NEON-BLACK-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 0,
      "active": true,
      "available": false,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/neon-and-black-shoe-shell-pair-1_4185fce2-fb89-4d13-9cd3-a2a5bb5c95af.jpg?v=1793074827"
    },
    {
      "productId": "8895274319926",
      "variantId": "46696717221942",
      "gid": "gid://shopify/ProductVariant/46696717221942",
      "handle": "orange-sandal-shell-pair",
      "sourceHandles": [],
      "title": "Orange",
      "fullTitle": "Orange Sandal Shell Pair",
      "kind": "sandal",
      "family": "sandal",
      "colorHandle": "orange",
      "colors": [
        "orange"
      ],
      "strapColor": "white",
      "sku": "SHL-SANDAL-ORANGE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 14,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/orange-sandal-shell-pair-1_59973718-58f8-4b1b-99f8-e4e4bf57ac45.jpg?v=1793074157"
    },
    {
      "productId": "8895274516534",
      "variantId": "46696717418550",
      "gid": "gid://shopify/ProductVariant/46696717418550",
      "handle": "orange-and-white-shoe-shell-pair",
      "sourceHandles": [
        "orange-white-golf-bag-stand-shoes"
      ],
      "title": "Orange & White",
      "fullTitle": "Orange & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "orange-and-white",
      "colors": [
        "orange",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-ORANGE-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 15,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/orange-and-white-shoe-shell-pair-1_f6260bd3-b3e3-4b04-9d75-1447b60f83dd.jpg?v=1793080336"
    },
    {
      "productId": "8895274549302",
      "variantId": "46696717451318",
      "gid": "gid://shopify/ProductVariant/46696717451318",
      "handle": "pink-and-black-shoe-shell-pair",
      "sourceHandles": [
        "pink-black-golf-bag-stand-shoes"
      ],
      "title": "Pink & Black",
      "fullTitle": "Pink & Black Shoe Shell Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "pink-and-black",
      "colors": [
        "black",
        "pink"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-PINK-BLACK-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 5,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/pink-and-black-shoe-shell-pair-1_23c7a51c-4eaa-4eab-bfcd-a09dee68fa96.jpg?v=1793074834"
    },
    {
      "productId": "8895274582070",
      "variantId": "46696717484086",
      "gid": "gid://shopify/ProductVariant/46696717484086",
      "handle": "pink-and-white-shoe-shell-pair",
      "sourceHandles": [
        "pink-white-shoes"
      ],
      "title": "Pink & White",
      "fullTitle": "Pink & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "pink-and-white",
      "colors": [
        "pink",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-PINK-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/pink-and-white-shoe-shell-pair-1_01a6b368-fd8c-4529-9f50-692cb3a5fd37.jpg?v=1793080343"
    },
    {
      "productId": "9587085705270",
      "variantId": "48318684364854",
      "gid": "gid://shopify/ProductVariant/48318684364854",
      "handle": "pink-camo-shoe-pair",
      "sourceHandles": [],
      "title": "Pink Camo",
      "fullTitle": "Pink Camo Shoe Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "pink-camo",
      "colors": [
        "pink",
        "purple",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-PINK-CAMO-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/pink-camo-shoe-pair-1.jpg?v=1793074178"
    },
    {
      "productId": "8895274614838",
      "variantId": "46696717516854",
      "gid": "gid://shopify/ProductVariant/46696717516854",
      "handle": "pink-black-and-white-shoe-shell-pair",
      "sourceHandles": [
        "pink-black-white-golf-bag-stand-shoes-copy"
      ],
      "title": "Pink/Black & White",
      "fullTitle": "Pink/Black & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "three-color",
      "colorHandle": "pink-black-and-white",
      "colors": [
        "black",
        "pink",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-PINK-BLACK-WHITE-PAIR",
      "priceCents": 1800,
      "inventoryQuantity": 16,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/pink-black-and-white-shoe-shell-pair-1_4957fab3-7fea-474f-b188-fa422fa0c447.jpg?v=1793073443"
    },
    {
      "productId": "8895274647606",
      "variantId": "46696717549622",
      "gid": "gid://shopify/ProductVariant/46696717549622",
      "handle": "purple-and-white-shoe-shell-pair",
      "sourceHandles": [
        "purple-white-golf-bag-stand-shoes"
      ],
      "title": "Purple & White",
      "fullTitle": "Purple & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "purple-and-white",
      "colors": [
        "purple",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-PURPLE-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 2,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/purple-and-white-shoe-shell-pair-1_00e2ffd1-3d1f-412c-b754-e9aa393b48f5.jpg?v=1793080351"
    },
    {
      "productId": "8895274352694",
      "variantId": "46696717254710",
      "gid": "gid://shopify/ProductVariant/46696717254710",
      "handle": "red-sandal-shell-pair",
      "sourceHandles": [],
      "title": "Red",
      "fullTitle": "Red Sandal Shell Pair",
      "kind": "sandal",
      "family": "sandal",
      "colorHandle": "red",
      "colors": [
        "red"
      ],
      "strapColor": "",
      "sku": "SHL-SANDAL-RED-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 13,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/red-sandal-shell-pair-1_6e8c61d4-aecb-4550-a421-c95f98cf8c67.jpg?v=1793074164"
    },
    {
      "productId": "8895274680374",
      "variantId": "46696717582390",
      "gid": "gid://shopify/ProductVariant/46696717582390",
      "handle": "red-and-black-shoe-shell-pair",
      "sourceHandles": [
        "red-black-golf-bag-stand-shoes"
      ],
      "title": "Red & Black",
      "fullTitle": "Red & Black Shoe Shell Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "red-and-black",
      "colors": [
        "black",
        "red"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-RED-BLACK-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 12,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/red-and-black-shoe-shell-pair-1_99e503e3-c95a-436a-805a-cd6519ec98bb.jpg?v=1793074842"
    },
    {
      "productId": "8895274713142",
      "variantId": "46696717615158",
      "gid": "gid://shopify/ProductVariant/46696717615158",
      "handle": "red-and-white-shoe-shell-pair",
      "sourceHandles": [
        "red-white-shoes"
      ],
      "title": "Red & White",
      "fullTitle": "Red & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "red-and-white",
      "colors": [
        "red",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-RED-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/red-and-white-shoe-shell-pair-1.jpg?v=1793073140"
    },
    {
      "productId": "8895274745910",
      "variantId": "46696717647926",
      "gid": "gid://shopify/ProductVariant/46696717647926",
      "handle": "red-white-and-blue-shoe-shell-pair",
      "sourceHandles": [
        "red-white-blue-golf-bag-stand-shoes"
      ],
      "title": "Red, White & Blue",
      "fullTitle": "Red, White & Blue Shoe Shell Pair",
      "kind": "shoe",
      "family": "three-color",
      "colorHandle": "red-white-and-blue",
      "colors": [
        "blue",
        "red",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-RED-WHITE-BLUE-PAIR",
      "priceCents": 1800,
      "inventoryQuantity": 9,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/red-white-and-blue-shoe-shell-pair-1_65f8709f-150f-48ca-93a0-e82d826104b5.jpg?v=1793073464"
    },
    {
      "productId": "8895274778678",
      "variantId": "46696717680694",
      "gid": "gid://shopify/ProductVariant/46696717680694",
      "handle": "red-black-and-white-shoe-shell-pair",
      "sourceHandles": [
        "red-black-white-golf-bag-stand-shoes"
      ],
      "title": "Red/Black & White",
      "fullTitle": "Red/Black & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "three-color",
      "colorHandle": "red-black-and-white",
      "colors": [
        "black",
        "red",
        "white"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-RED-BLACK-WHITE-PAIR",
      "priceCents": 1800,
      "inventoryQuantity": 8,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/red-black-and-white-shoe-shell-pair-1_334e370c-d970-4a0d-936a-cceac4d97016.jpg?v=1793073450"
    },
    {
      "productId": "8895274254390",
      "variantId": "46696717156406",
      "gid": "gid://shopify/ProductVariant/46696717156406",
      "handle": "sasquatch-feet-shell-pair",
      "sourceHandles": [
        "golf-bag-sasquatch-feet"
      ],
      "title": "Sasquatch Feet",
      "fullTitle": "Sasquatch Feet Shell Pair",
      "kind": "sasquatch",
      "family": "sandal",
      "colorHandle": "sasquatch-feet",
      "colors": [
        "brown"
      ],
      "strapColor": "",
      "sku": "SHL-SASQUATCH-FEET-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 41,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/sasquatch-feet-shell-pair-1_487dd351-7a4c-4ee2-81dc-0c9e076de929.jpg?v=1793074144"
    },
    {
      "productId": "9501529309238",
      "variantId": "48080431153206",
      "gid": "gid://shopify/ProductVariant/48080431153206",
      "handle": "sugar-skull-shoe-pair",
      "sourceHandles": [],
      "title": "Sugar Skull",
      "fullTitle": "Sugar Skull Shoe Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "sugar-skull",
      "colors": [
        "orange",
        "black"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-SUGAR-SKULL-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 14,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/sugar-skull-shoe-pair-1_e5f34c77-bba2-4b73-8136-e5aa8e6645a9.jpg?v=1793074857"
    },
    {
      "productId": "9587086000182",
      "variantId": "48318684987446",
      "gid": "gid://shopify/ProductVariant/48318684987446",
      "handle": "traditional-camo-shoe-pair",
      "sourceHandles": [],
      "title": "Traditional Camo",
      "fullTitle": "Traditional Camo Shoe Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "traditional-camo",
      "colors": [
        "green",
        "brown",
        "black"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-TRADITIONAL-CAMO-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/traditional-camo-shoe-pair-1.jpg?v=1793080408"
    },
    {
      "productId": "8895274811446",
      "variantId": "46696717713462",
      "gid": "gid://shopify/ProductVariant/46696717713462",
      "handle": "yellow-and-black-shoe-shell-pair",
      "sourceHandles": [
        "yellow-black-golf-bag-stand-shoes"
      ],
      "title": "Yellow & Black",
      "fullTitle": "Yellow & Black Shoe Shell Pair",
      "kind": "shoe",
      "family": "premium",
      "colorHandle": "yellow-and-black",
      "colors": [
        "black",
        "yellow"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-YELLOW-BLACK-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 1,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/yellow-and-black-shoe-shell-pair-1.jpg?v=1793080403"
    },
    {
      "productId": "8895274844214",
      "variantId": "46696717746230",
      "gid": "gid://shopify/ProductVariant/46696717746230",
      "handle": "yellow-and-white-shoe-shell-pair",
      "sourceHandles": [
        "yellow-white-golf-bag-stand-shoes"
      ],
      "title": "Yellow & White",
      "fullTitle": "Yellow & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "two-color",
      "colorHandle": "yellow-and-white",
      "colors": [
        "white",
        "yellow"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-YELLOW-WHITE-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 9,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/yellow-and-white-shoe-shell-pair-1_ec6c5055-b6bf-4347-b3a7-027c330d924f.jpg?v=1793080358"
    },
    {
      "productId": "8895274876982",
      "variantId": "46696717778998",
      "gid": "gid://shopify/ProductVariant/46696717778998",
      "handle": "yellow-black-and-white-shoe-shell-pair",
      "sourceHandles": [
        "yellow-black-white-golf-bag-stand-shoes"
      ],
      "title": "Yellow/Black & White",
      "fullTitle": "Yellow/Black & White Shoe Shell Pair",
      "kind": "shoe",
      "family": "three-color",
      "colorHandle": "yellow-black-and-white",
      "colors": [
        "black",
        "white",
        "yellow"
      ],
      "strapColor": "",
      "sku": "SHL-SHOE-YELLOW-BLACK-WHITE-PAIR",
      "priceCents": 1800,
      "inventoryQuantity": 16,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/yellow-black-and-white-shoe-shell-pair-1.jpg?v=1793080376"
    },
    {
      "productId": "9587086491702",
      "variantId": "48318685970486",
      "gid": "gid://shopify/ProductVariant/48318685970486",
      "handle": "yeti-feet-pair",
      "sourceHandles": [],
      "title": "Yeti Feet",
      "fullTitle": "Yeti Feet Pair",
      "kind": "sasquatch",
      "family": "sandal",
      "colorHandle": "yeti-feet",
      "colors": [
        "white",
        "blue"
      ],
      "strapColor": "",
      "sku": "SHL-YETI-FEET-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 10,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/yeti-feet-pair-1.jpg?v=1793074199"
    }
  ],
  "inserts": [
    {
      "productId": "8895273992246",
      "variantId": "46696716894262",
      "gid": "gid://shopify/ProductVariant/46696716894262",
      "handle": "shoobie-inserts",
      "title": "Small",
      "sku": "INS-SMALL-PAIR",
      "priceCents": 2000,
      "inventoryQuantity": 5,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-inserts-1.jpg?v=1793073207"
    },
    {
      "productId": "8895273992246",
      "variantId": "46696716861494",
      "gid": "gid://shopify/ProductVariant/46696716861494",
      "handle": "shoobie-inserts",
      "title": "Standard",
      "sku": "INS-STANDARD-PAIR",
      "priceCents": 1500,
      "inventoryQuantity": 198,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-inserts-1.jpg?v=1793073207"
    }
  ],
  "laces": [
    {
      "productId": "9078024994870",
      "variantId": "47038373068854",
      "gid": "gid://shopify/ProductVariant/47038373068854",
      "handle": "shoobie-laces-1",
      "title": "Black",
      "colorHandle": "black",
      "sku": "LAC-ALC-BLACK-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 30,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-3_4994992f-50b6-44f0-8fe0-e6be218e20a6.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373298230",
      "gid": "gid://shopify/ProductVariant/47038373298230",
      "handle": "shoobie-laces-1",
      "title": "Blue",
      "colorHandle": "blue",
      "sku": "LAC-ALC-BLUE-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 45,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-11_917c7da8-f349-49f3-8e26-960c3de6c546.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373363766",
      "gid": "gid://shopify/ProductVariant/47038373363766",
      "handle": "shoobie-laces-1",
      "title": "Bright Teal",
      "colorHandle": "bright-teal",
      "sku": "LAC-ALC-BRIGHT-TEAL-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 48,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-13.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373167158",
      "gid": "gid://shopify/ProductVariant/47038373167158",
      "handle": "shoobie-laces-1",
      "title": "Brown",
      "colorHandle": "brown",
      "sku": "LAC-ALC-BROWN-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 49,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-7_e79be342-9411-4a06-a05a-4fb5c556f89f.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373134390",
      "gid": "gid://shopify/ProductVariant/47038373134390",
      "handle": "shoobie-laces-1",
      "title": "Green",
      "colorHandle": "green",
      "sku": "LAC-ALC-GREEN-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 46,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-6_ced345eb-2f48-4400-ae94-2018c4431218.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "48319418499126",
      "gid": "gid://shopify/ProductVariant/48319418499126",
      "handle": "shoobie-laces-1",
      "title": "Grey",
      "colorHandle": "grey",
      "sku": "LAC-ALC-GREY-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 25,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-4_6799e0ff-2c57-4a6c-a283-c04108744cfe.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373330998",
      "gid": "gid://shopify/ProductVariant/47038373330998",
      "handle": "shoobie-laces-1",
      "title": "Hot Pink",
      "colorHandle": "hot-pink",
      "sku": "LAC-ALC-HOT-PINK-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 49,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-12_86531135-2cdd-4b80-83bb-832cc75e083f.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373232694",
      "gid": "gid://shopify/ProductVariant/47038373232694",
      "handle": "shoobie-laces-1",
      "title": "Orange",
      "colorHandle": "orange",
      "sku": "LAC-ALC-ORANGE-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 41,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-9_d8913389-7922-434b-ba09-fd9a8a5058b6.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373101622",
      "gid": "gid://shopify/ProductVariant/47038373101622",
      "handle": "shoobie-laces-1",
      "title": "Pink",
      "colorHandle": "pink",
      "sku": "LAC-ALC-PINK-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 47,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-5_f8d670ea-4460-475f-9ec9-709c4ef33982.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373265462",
      "gid": "gid://shopify/ProductVariant/47038373265462",
      "handle": "shoobie-laces-1",
      "title": "Purple",
      "colorHandle": "purple",
      "sku": "LAC-ALC-PURPLE-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 48,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-10_c91df834-09ad-455a-aa2b-a93a03b87cc6.jpg?v=1793071337"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373036086",
      "gid": "gid://shopify/ProductVariant/47038373036086",
      "handle": "shoobie-laces-1",
      "title": "Red",
      "colorHandle": "red",
      "sku": "LAC-ALC-RED-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 36,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-2_f2f77f34-45e5-49f8-9e85-2a2a6b11484e.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373003318",
      "gid": "gid://shopify/ProductVariant/47038373003318",
      "handle": "shoobie-laces-1",
      "title": "White",
      "colorHandle": "white",
      "sku": "LAC-ALC-WHITE-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 47,
      "active": true,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-1_1c101dee-b06f-481e-89a7-aa38a9ca472c.jpg?v=1793071336"
    },
    {
      "productId": "9078024994870",
      "variantId": "47038373199926",
      "gid": "gid://shopify/ProductVariant/47038373199926",
      "handle": "shoobie-laces-1",
      "title": "Yellow",
      "colorHandle": "yellow",
      "sku": "LAC-ALC-YELLOW-PAIR",
      "priceCents": 0,
      "inventoryQuantity": 0,
      "active": true,
      "available": false,
      "image": "https://cdn.shopify.com/s/files/1/0613/5873/5414/files/shoobie-laces-1-8_664e816b-9840-49dd-bdf5-b789c1f11040.jpg?v=1793071336"
    }
  ]
};
